import { render } from "./ProfilesList.vue?vue&type=template&id=4d881c5a&scoped=true"
import script from "./ProfilesList.vue?vue&type=script&lang=js"
export * from "./ProfilesList.vue?vue&type=script&lang=js"

import "./ProfilesList.vue?vue&type=style&index=0&id=4d881c5a&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d881c5a"]])

export default __exports__